import Head from '@/next/components/Head/Head';

export default Head;
